import React, {useContext} from "react";
import {RecordsManagementContext} from "../StatesMangement/InitialiseContext";

// Common function to show 'PRINT INVOICE' Button in client portal Bols. And download Invoice PDF according to bol type.
export default () => {
    let Record = useContext(RecordsManagementContext)
    let EstimateID = Record.IV1_PageDetails.pdf_est_id || Record.IV2_PageDetails.pdf_est_id
    let BolType = Record.IV1_PageDetails.bol_type || Record.IV2_PageDetails.bol_type
    let Url = Record.IV1_PageDetails.url || Record.IV2_PageDetails.url

    const printInvoice =  async () => {
        if (BolType === 'BOL, V2'){
            Url = Url + '/print_invoice_2?id=' + EstimateID
        } else if (BolType === 'Texas BOL'){
            Url = Url + '/print_texas_bol_invoice?id=' + EstimateID
        } else {
            Url = Url + '/print_invoice_by_client?id=' + EstimateID
        }
        window.open(Url)
    }
    return (
        <button className='btn btn-dark btn-sm m-lg-2'
                onClick={()=> printInvoice()}  ><b>PRINT INVOICE</b></button>
    )
}